var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_133239)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_422_133239)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3472 25.0891C54.3472 36.7349 42.7755 46.177 28.5 46.177C25.3141 46.177 22.263 45.7072 19.4445 44.8464L4.59137 51.7589L10.407 40.1479C5.62189 36.3202 2.65283 30.989 2.65283 25.0891C2.65283 13.4421 14.2245 4 28.5 4C42.7755 4 54.3472 13.4421 54.3472 25.0891Z",
    stroke: "#0B132B",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6236 33.2186C29.3284 33.2186 29.0361 33.2767 28.7634 33.3897C28.4908 33.5026 28.243 33.6682 28.0343 33.8769C27.8256 34.0856 27.66 34.3333 27.5471 34.606C27.4341 34.8787 27.376 35.171 27.376 35.4661C27.376 35.7613 27.4341 36.0536 27.5471 36.3263C27.66 36.5989 27.8256 36.8467 28.0343 37.0554C28.243 37.2641 28.4908 37.4297 28.7634 37.5426C29.0361 37.6556 29.3284 37.7137 29.6236 37.7137C30.2197 37.7137 30.7913 37.4769 31.2128 37.0554C31.6343 36.6339 31.8711 36.0622 31.8711 35.4661C31.8711 34.8701 31.6343 34.2984 31.2128 33.8769C30.7913 33.4554 30.2197 33.2186 29.6236 33.2186Z",
    fill: "#0B132B",
    stroke: "#0B132B",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8809 21.1356C22.8809 17.4136 25.8994 14.2535 29.6236 14.2535C33.3467 14.2535 36.3663 17.2046 36.3663 20.9265C36.3663 24.6519 33.3467 27.5996 29.6236 27.5996V30.4068",
    stroke: "#0B132B",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_133239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.169922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_422_133239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.169922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc8);
export default __webpack_public_path__ + "static/media/doc8.c4d7a2a2af6722f143755c31b127a85a.svg";
export { ForwardRef as ReactComponent };